export const initCookieConsent = (): void => {
  const banner = document.getElementById("cookie-consent-banner");
  const btnAccept = document.getElementById("btn-cookie-accept");
  const btnDecline = document.getElementById("btn-cookie-decline");

  if (!banner || !btnAccept || !btnDecline) return;

  const cookieName = "theme_cookie_consent";

  // Helper to get cookie
  const getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(";").shift();
    return null;
  };

  // Helper to set cookie (1 year expiry)
  const setCookie = (name: string, value: string) => {
    const date = new Date();
    date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/; SameSite=Lax`;
  };

  // Check if user has already made a choice
  if (!getCookie(cookieName)) {
    // Small delay to allow page render, then slide up
    setTimeout(() => {
      banner.classList.add("is-visible");
      banner.setAttribute("aria-hidden", "false");
    }, 1000);
  }

  const hideBanner = () => {
    banner.classList.remove("is-visible");
    banner.setAttribute("aria-hidden", "true");
  };

  // Handle Accept
  btnAccept.addEventListener("click", () => {
    setCookie(cookieName, "accepted");
    hideBanner();

    // Dynamically update Google Consent Mode state without reloading
    if (typeof (window as any).gtag === "function") {
      (window as any).gtag("consent", "update", {
        ad_storage: "granted",
        analytics_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
      });
      console.log("[Cookie] Consent granted. GA4 updated.");
    }
  });

  // Handle Decline
  btnDecline.addEventListener("click", () => {
    setCookie(cookieName, "declined");
    hideBanner();
    console.log("[Cookie] Consent declined.");
  });
};
